import { EnquiryFormData } from "@/model/schemas";
import {
  AmountField as BaseAmountField,
  ConsentField as BaseConsentField,
  SelectField as BaseSelectField,
  TextField as BaseTextField,
} from "../../site/FormFields";

export type { Option } from "../../site/FormFields";

export type EnquiryField = keyof EnquiryFormData;

export const TextField = BaseTextField<EnquiryFormData>;
export const AmountField = BaseAmountField<EnquiryFormData>;
export const SelectField = BaseSelectField<EnquiryFormData>;
export const ConsentField = BaseConsentField<EnquiryFormData>;
